<template>
    <div class="container">
        <b-container fluid v-if="!showPage">
              <b-row>
                <div class="text-center m-5">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>&nbsp;Loading...</strong>
                </div>
              </b-row>
        </b-container>   
        <b-container fluid v-if="showPage" style="margin-top:100px;">
            <b-row style="text-align: left;">
                <b-col>
                    <br>
                    <h3>Standard Nucleotide BLAST</h3>
                </b-col>
            </b-row>            
            <b-row>
                <b-col align-self="center">
                    <hr>                    
                </b-col>
            </b-row>
            <b-row style="text-align: left;">
                <b-col>
                    <b-form-group
                    label="Enter FASTA sequences"
                    label-for="textarea"
                    >
                    <b-form-textarea
                    id="textarea"
                    v-model="fSeqTArea"
                    rows="3"
                    max-rows="6"
                    ></b-form-textarea>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row style="text-align: left;">
                <b-col sm="2">Upload File</b-col>
                <b-col>
                        <b-form-file
                            v-model="upFile"
                            :state="Boolean(upFile)"
                            placeholder="Choose a file or drop it here..."
                            drop-placeholder="Drop file here..."
                        ></b-form-file>
                </b-col>
            </b-row>
             <b-row style="text-align: left;padding-top:12px">
                <b-col sm="2">Job title</b-col>
                <b-col>
                    <b-form-input id="jobNameTF" v-model="jobName" type="text" ></b-form-input>                    
                </b-col>                 
             </b-row>
             <b-row style="padding-top:15px">
                 <b-col>
                     <b-button variant="danger" @click="clearInput()">
                        Cancel
                    </b-button>
                    <b-button variant="success" style="margin-left:5px" @click="submitBlastRequest()">
                        Submit
                    </b-button>
                 </b-col>
             </b-row>
             <br>           
        </b-container>
    </div>
</template>

<script>
import axios from 'axios'
import MD5 from "crypto-js/md5";
import router from '../router'

export default {
    data () {
        return{
            server_add:"https://mai.fudan.edu.cn/",
            showPage:true,
            upFile:null,
            fSeqTArea:'',
            jobName:''
        }
    },
    watch: {        
        upFile(file){
            var reader = new FileReader();
            reader.readAsText(file);
            reader.onload = (event) => {
                this.upFileContStr = event.target.result;
                this.fSeqTArea = this.upFileContStr
            }
        }
    },
    mounted() {        
    },
    methods: {
        submitBlastRequest(){
            var seq = this.fSeqTArea
            if(seq.length <=0){
                seq = this.upFileContStr
            }
            var isFasta = this.validateFasta(seq)
            var firstLi = this.getFirstLine(seq)
            if(this.jobName.length<=0){
                this.jobName = firstLi.replace('>','')
            }
            const today = new Date()
            var dates_as_int = Number(today.getTime()*.001)
            var uniqId =this.uuidv4()+''+MD5(firstLi).toString()+dates_as_int
            // console.log(this.uuidv4(),MD5(firstLi).toString())
            if(isFasta){
                axios.post(this.server_add+'query/doBlast',
                {
                    bseq:seq,
                    name:this.jobName,
                    sysid:uniqId
                }).then(retDat => {
                    if(retDat.status == 200){
                        var queryId = retDat.data.query_id
                        router.push({ path: `/blastResults/${queryId}` }) // -> /user/123                        
                        // router.push({ name: 'nBlastResults' ,params: { blastId: queryId }})
                    }else{
                        this.showErrorMessage('Query not submitted!Try again later')
                    }
                }).catch(err => {
                    this.showErrorMessage('Error processing request:'+err)
                })
            }else{
                this.showErrorMessage('Error with input file format!!Submit only FASTA')
            }
        },
        uuidv4() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
            });
        },
        showErrorMessage(errorMsg) {
            this.$bvModal.msgBoxOk(errorMsg, {
            title: 'Confirmation',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true
            })
            .then(value => {
                if(value){ //reloading the page
                    this.clearInput()
                }
            })
            .catch(err => {
                // An error occurred
            })
        },
        validateFasta(fasta) {
            if (!fasta) { // check there is something first of all
                return false;
            }
            fasta = fasta.trim();
            if(!fasta.match('>')){
                return false
            }
            var lines = fasta.split('\n');
            if (fasta[0] == '>') {
                lines.splice(0, 1);
            }
            fasta = lines.join('').trim();
            if (!fasta) { // is it empty whatever we collected ? re-check not efficient 
                return false;
            }
            return /^[ACDEFGHIKLMNPQRSTUVWY\s]+$/i.test(fasta);
        },
        getFirstLine(fasta){
            if (!fasta) { // check there is something first of all
                return false;
            }
            fasta = fasta.trim();
            var lines = fasta.split('\n');
            fasta = lines[0].trim();
            if (!fasta) { // is it empty whatever we collected ? re-check not efficient 
                return '';
            }
            return fasta
        },
        genSysId(){
            var id = ''
            return id
        },
        clearInput(){
            this.upFileContStr = ''
            this.fSeqTArea = ''
            this.jobName = ''
        },
    },
}
</script>

<style lang="less">
    #boxBg{
    background-color: #ECE9E9;
    padding-top: 10px;
    padding-bottom: 5px;
    padding-left: 5px;
    align-content: left;
    color: black;
}

.medium_col{
  width: 140px !important;
  height: 25px !important;
  max-height: 25px !important;
  max-width: 140px !important;
  text-align: center;
}
</style>